import { alertsApi } from '@innovyze/stylovyze/lib/apis';
export const getAlertByIdApi = (alertId) => alertsApi.get(`/alert/${alertId}`);
export const updateAlert = (alertId, updateAlertRequest) => {
    return alertsApi.put(`/alert/${alertId}`, updateAlertRequest);
};
